/**
 * http配置
 */
// 引入axios以及element ui中的loading和message组件
import axios from 'axios'
import { Loading, Message } from 'element-ui'
// 超时时间
axios.defaults.timeout = 50000
// http请求拦截器
var loadinginstace
axios.interceptors.request.use(config => {
  // console.log('拦截器传入config', config)
  // element ui Loading方法
  loadinginstace = Loading.service({ fullscreen: true, text: '拼命加载中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.5)' })
  return config
}, error => {
  // console.log('request error', error)
  loadinginstace.close()
  // Message.error({
  //   message: '请求超时'
  // })
  return Promise.reject(error)
})
// http响应拦截器
axios.interceptors.response.use(response => { // 响应成功关闭loading
  // console.log('response data！！！', response)
  loadinginstace.close()
  return response
}, error => {
  loadinginstace.close()
  // if (error) {
  //   console.log('error！！！', error)
  // }
  console.log(error)
  if (error.response) {
    console.log('response error！！！', error.response)
    switch (error.response.status) {
      case 401:
        // 返回 401 清除token信息并跳转到登录页面
        // store.commit(types.LOGOUT)
        // router.replace({
        //   path: 'login',
        //   query: {redirect: router.currentRoute.fullPath}
        // })
        Message.error({
          message: '授权授权授权授权失败'
        })
    }
  }
  // Message.error({
  //   message: '响应失败'
  // })
  return Promise.reject(error)
})
export default axios



// WEBPACK FOOTER //
// ./src/assets/js/http.js